import { inject, Injectable } from '@angular/core';
import { Environment } from './environment.interface';
import { isBetaEnvironment } from './environment.utils';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    private _env = inject(Environment);

    getVersion(): string {
        return (window as any).APP_VERSION || 'unknown';
    }

    isBetaEnvironment(): boolean {
        return isBetaEnvironment(this._env.currentMode);
    }
}
